/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_2_QuoteInputs */

const en_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every AI-tailored resume is checked against your original. Fabricated companies or titles are automatically caught and removed.`)
};

const de_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder KI-angepasste Lebenslauf wird mit deinem Original abgeglichen. Erfundene Firmen oder Jobtitel werden automatisch erkannt und entfernt.`)
};

const fr_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque CV adapté par l'IA est vérifié par rapport à ton original. Les entreprises ou titres inventés sont automatiquement détectés et supprimés.`)
};

const es_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada currículum adaptado por IA se compara con tu original. Las empresas o títulos inventados se detectan y eliminan automáticamente.`)
};

const it_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni curriculum adattato dall'AI viene confrontato con l'originale. Aziende o titoli inventati vengono automaticamente individuati e rimossi.`)
};

const nl_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk AI-aangepast CV wordt gecontroleerd tegen je origineel. Verzonnen bedrijven of functietitels worden automatisch opgespoord en verwijderd.`)
};

const pl_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każde CV dopasowane przez AI jest sprawdzane z Twoim oryginałem. Zmyślone firmy czy stanowiska są automatycznie wychwytywane i usuwane.`)
};

const fi_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen tekoälyn räätälöimä ansioluettelo tarkistetaan alkuperäistäsi vasten. Keksityt yritykset tai tehtävänimikkeet havaitaan ja poistetaan automaattisesti.`)
};

const da_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvert AI-tilpasset CV kontrolleres mod dit originale. Opdigtede virksomheder eller titler bliver automatisk fanget og fjernet.`)
};

const sv_landing_testimonial_2_quote = /** @type {(inputs: Landing_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje AI-anpassat CV kontrolleras mot ditt original. Påhittade företag eller titlar fångas upp och tas bort automatiskt.`)
};

/**
* | output |
* | --- |
* | "Every AI-tailored resume is checked against your original. Fabricated companies or titles are automatically caught and removed." |
*
* @param {Landing_Testimonial_2_QuoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_2_quote = /** @type {((inputs?: Landing_Testimonial_2_QuoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_2_QuoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_2_quote(inputs)
	if (locale === "fr") return fr_landing_testimonial_2_quote(inputs)
	if (locale === "es") return es_landing_testimonial_2_quote(inputs)
	if (locale === "it") return it_landing_testimonial_2_quote(inputs)
	if (locale === "nl") return nl_landing_testimonial_2_quote(inputs)
	if (locale === "pl") return pl_landing_testimonial_2_quote(inputs)
	if (locale === "fi") return fi_landing_testimonial_2_quote(inputs)
	if (locale === "da") return da_landing_testimonial_2_quote(inputs)
	if (locale === "sv") return sv_landing_testimonial_2_quote(inputs)
	return en_landing_testimonial_2_quote(inputs)
});